import { useSelector } from 'react-redux';
import { Text, Flex, Box } from '@chakra-ui/react';
import { TState } from '../../redux/store';

const Logo = ({ big, dark }: { big?: boolean; dark?: boolean }) => {
  const theme = useSelector((state: TState) => state.theme);

  return (
    <Flex align='center' gap={2} whiteSpace='nowrap'>
      {/* Icône + badge */}
      <Box position='relative'>
        <Flex
          w='2rem'
          h='2rem'
          bgGradient='linear(to-br, #2563eb, #60a5fa)'
          rounded='lg'
          align='center'
          justify='center'
        >
          <Box
            as='svg'
            w='1.25rem'
            h='1.25rem'
            fill='currentColor'
            viewBox='0 0 24 24'
            color='white'
          >
            <path d='M6 4h12v3H9v3h8v3H9v3h9v3H6V4z' />
          </Box>
        </Flex>

        {/* Badge vert */}
        <Box
          position='absolute'
          top='-2px'
          right='-2px'
          w='0.75rem'
          h='0.75rem'
          bg='rgb(74 222 128)'
          rounded='full'
          border='2px solid white'
        />
      </Box>

      {/* Texte */}
      {big && (
        <Text
          fontWeight='bold'
          fontSize='xl'
          fontFamily='ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";'
        >
          <Text
            as='span'
            bgGradient='linear(to-r, #2563eb, #60a5fa)'
            bgClip='text'
          >
            Evision
          </Text>
          <Text as='span' color={dark ? '#fff' : theme.main}>
            CRM
          </Text>
        </Text>
      )}
    </Flex>
  );
};

export default Logo;
